export const FETCH_STAGE = 'features/OnBoardingStage/FETCH_STAGE' as string;
export const FETCH_ONBOARDED = 'features/OnBoardingStage/FETCH_ONBOARDED' as string;